import { useDisclosure } from "@mantine/hooks"
import { CaretDown, Paperclip, Trash } from "@phosphor-icons/react"
import { Button } from "@vesatogo/grass-core"
import classNames from "classnames"
import React from "react"

interface CollapsibleItemProps {
  index: number
  onRemove: () => void
  onAttach?: () => void
  attachmentCount?: number
  children: React.ReactNode
  detailTable?: React.ReactNode
  disableDelete?: boolean
  disableAttachment?: boolean
}

const CollapsibleItem = ({
  index,
  onRemove,
  onAttach,
  attachmentCount,
  children,
  detailTable,
  disableDelete,
  disableAttachment,
}: CollapsibleItemProps) => {
  const [opened, { toggle }] = useDisclosure(true)

  return (
    <div className="border border-gray-300 rounded-lg group relative last:mb-0 mb-4 pb-3">
      <div className="flex items-center gap-3 mb-2 p-3">
        <div className="flex items-center gap-2 text-gray-700 mt-5">
          <CaretDown
            size={14}
            className={classNames("cursor-pointer transition-transform", {
              "-rotate-90": !opened,
            })}
            onClick={toggle}
          />
          <div className="w-6 h-6 rounded-full border bg-gray-100 flex items-center justify-center text-xs font-bold text-gray-400">
            {index + 1}
          </div>
        </div>
        <div className="flex-1">{children}</div>
        <div className="flex items-center gap-4 mt-5">
          {onAttach && (
            <Button
              variant="ghost"
              leftIcon={<Paperclip size={14} />}
              onClick={onAttach}
              intent="info"
              size="sm"
              disabled={disableAttachment}
            >
              {attachmentCount || 0}
            </Button>
          )}

          <Trash
            className={classNames("text-gray-400 cursor-pointer", {
              "!opacity-50 !cursor-not-allowed": disableDelete,
            })}
            size={15}
            onClick={disableDelete ? undefined : onRemove}
          />
        </div>
      </div>
      {opened && detailTable ? detailTable : undefined}
    </div>
  )
}

export default CollapsibleItem
